var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPenAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.631 2.40997C18.1777 1.86334 19.0639 1.86334 19.6105 2.40997L21.59 4.38947C22.1367 4.93609 22.1367 5.82234 21.59 6.36897L8.53941 19.4196C8.52955 19.4295 8.51962 19.4392 8.50962 19.4489L4.55106 15.4904C4.56077 15.4804 4.57055 15.4705 4.58041 15.4606L14.9902 5.05083L14.8839 4.94454C14.3957 4.45639 13.6043 4.45639 13.1161 4.94454L10.5303 7.53033C10.2374 7.82322 9.76257 7.82322 9.46968 7.53033C9.17679 7.23744 9.17679 6.76256 9.46968 6.46967L12.0555 3.88388C13.1294 2.80994 14.8706 2.80994 15.9445 3.88388L16.0508 3.99017L17.631 2.40997Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.77948 16.8401L2.05274 21.0336C1.94516 21.2949 2.00522 21.5952 2.205 21.795C2.40479 21.9948 2.7051 22.0548 2.96635 21.9473L7.15986 20.2205L3.77948 16.8401Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenAlt);
export default __webpack_public_path__ + "static/media/pen-alt.08b54b9a4e84fc8acaba36c3bd7511a0.svg";
export { ForwardRef as ReactComponent };